import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import cn from 'classnames';
import { useFormikContext } from 'formik';
import SsnInput from '../../components/SsnInput';
import { SSN_CONFIG_TYPES } from 'utils/constants';
import styles from '../../UserDetails.module.css';

const SsnSection = ({ show, isSsnRequired, ssnType, isInformationMismatched, askForFallback }) => {
    const { touched, errors, setFieldValue } = useFormikContext();

    if (!show) return null;

    const disablePartial = ssnType === SSN_CONFIG_TYPES.PARTIAL;

    return (
        <>
            <p className={styles.sectionHeader}>SSN Details</p>

            <Form.Row className={cn(styles.formRow, styles.ssnRow)}>
                <Col md={12} xs={12}>
                    <SsnInput
                        label="SSN"
                        isRequired={isSsnRequired}
                        onChange={(ssn) => setFieldValue('ssn', ssn)}
                        error={touched.ssn && Boolean(errors.ssn)}
                        helperText={touched.ssn && errors.ssn}
                        disableFirst={disablePartial}
                        disableSecond={disablePartial}
                        disableAll={isInformationMismatched}
                        autoFocus={Boolean(askForFallback)}
                    />
                </Col>
                <Col md={12} xs={12}>
                    <SsnInput
                        label="Confirm SSN"
                        isRequired={isSsnRequired}
                        onChange={(ssn) => setFieldValue('confirmSSN', ssn)}
                        error={touched.confirmSSN && Boolean(errors.confirmSSN)}
                        helperText={touched.confirmSSN && errors.confirmSSN}
                        disableFirst={disablePartial}
                        disableSecond={disablePartial}
                        disableAll={isInformationMismatched}
                    />
                </Col>
            </Form.Row>
        </>
    );
};

SsnSection.propTypes = {
    show: PropTypes.any,
    isSsnRequired: PropTypes.any,
    ssnType: PropTypes.any,
    isInformationMismatched: PropTypes.bool,
    askForFallback: PropTypes.any,
};

export default SsnSection;
